/*
  Kalessie - free-shipping progress bar
  ------------------------------------------------------------------
  Keeps every `.kal-ship-bar` (header row 2 + cart page) in sync with
  the live cart subtotal. Threshold comes from window.KAL.freeShippingThreshold
  (set in theme.liquid from the global "Kalessie" theme setting).

  Integrates with Dawn's pub/sub cart events; falls back to /cart.js so the
  total is always authoritative regardless of the event payload shape.
*/
(function () {
  function threshold() {
    return (window.KAL && Number(window.KAL.freeShippingThreshold)) || 150;
  }

  function prefix() {
    return (window.KAL && window.KAL.moneyPrefix) || 'AED';
  }

  function render(totalCents) {
    var total = (Number(totalCents) || 0) / 100;
    var limit = threshold();
    var gap = Math.max(0, limit - total);
    var pct = limit > 0 ? Math.min(100, (total / limit) * 100) : 100;
    var unlocked = gap <= 0;

    document.querySelectorAll('.kal-ship-bar').forEach(function (bar) {
      bar.classList.toggle('is-unlocked', unlocked);

      var fill = bar.querySelector('.kal-ship-fill');
      if (fill) fill.style.width = pct + '%';

      var label = bar.querySelector('.kal-ship-label');
      if (label) {
        label.textContent = unlocked
          ? '🎉 Free delivery unlocked!'
          : 'Add ' + prefix() + ' ' + gap.toFixed(0) + ' more ✓';
      }
      var pctEl = bar.querySelector('.kal-ship-pct');
      if (pctEl) pctEl.textContent = Math.round(pct) + '%';
    });
  }

  function refreshFromServer() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    fetch(base + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.total_price); })
      .catch(function () {});
  }

  function handleCartData(cart) {
    if (cart && typeof cart.total_price === 'number') {
      render(cart.total_price);
    } else {
      refreshFromServer();
    }
  }

  function init() {
    if (!document.querySelector('.kal-ship-bar')) return;

    // Initial paint from the server-rendered total (no fetch, no layout shift).
    var seed = document.querySelector('[data-kal-cart-total]');
    if (seed) {
      render(parseInt(seed.getAttribute('data-kal-cart-total'), 10));
    } else {
      refreshFromServer();
    }

    // Dawn publishes cartUpdate on add / change / remove (pubsub.js + constants.js,
    // loaded with defer before this file so the globals exist here).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        handleCartData(event && event.cartData);
      });
    }

    // Generic event for custom dispatchers / the redesigned cart page (Sprint 2).
    document.addEventListener('cart:updated', function (e) {
      handleCartData(e.detail && e.detail.cart);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
